// src/components/SocialProof.js
import React from 'react';
import { SiInstagram, SiFacebook, SiX, SiLinkedin, SiPinterest, SiYoutube, SiTiktok, SiShopify, SiSalesforce, SiFigma, SiNotion, SiCanva } from 'react-icons/si';

const integrations = [
  { name: 'Instagram', icon: SiInstagram },
  { name: 'Facebook', icon: SiFacebook },
  { name: 'X', icon: SiX },
  { name: 'LinkedIn', icon: SiLinkedin },
  { name: 'Shopify', icon: SiShopify },
  { name: 'Salesforce', icon: SiSalesforce },
  { name: 'Figma', icon: SiFigma },
  { name: 'Pinterest', icon: SiPinterest },
  { name: 'YouTube', icon: SiYoutube },
  { name: 'Notion', icon: SiNotion },
  { name: 'Canva', icon: SiCanva },
  { name: 'TikTok', icon: SiTiktok },
];

const SocialProof = () => {
  return (
    <section className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <h2 className="text-center text-lg font-semibold leading-8 text-dark-text-primary">
          Integrates seamlessly with the tools you already use
        </h2>
        <div 
          className="w-full inline-flex flex-nowrap overflow-hidden mt-16
          [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)]"
        >
          <ul className="flex items-center justify-center md:justify-start [&_li]:mx-10 animate-infinite-scroll">
            {integrations.map((integration) => (
              <li key={integration.name}>
                <integration.icon title={integration.name} className="h-8 w-auto text-dark-text-secondary/40 transition-colors hover:text-dark-text-primary" />
              </li>
            ))}
          </ul>
          <ul className="flex items-center justify-center md:justify-start [&_li]:mx-10 animate-infinite-scroll" aria-hidden="true">
            {integrations.map((integration) => (
              <li key={integration.name}>
                <integration.icon title={integration.name} className="h-8 w-auto text-dark-text-secondary/40 transition-colors hover:text-dark-text-primary" />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;